import { Box, Grid, Paper } from '@material-ui/core';
import Link from '@material-ui/core/Link';
import { headerHeight } from 'components/AuthLayout/styled';
import Typography from 'components/UI/Typography';
import { Color } from 'modules/styles/colors';
import { Spacing, smallFontSize, fontFamily } from 'modules/styles/variables';
import styled from 'styled-components';
import { dfdDefaultTheme, MuiBox } from 'theme/material-ui';

export const RegNotificationImg = styled.img`
  ${dfdDefaultTheme.breakpoints.between('xs', 'md')} {
    max-width: 175px;
    height: 175px;
  }
  max-width: 275px;
  height: 275px;
`;

export const RegImg = styled.img`
  ${dfdDefaultTheme.breakpoints.between('xs', 'md')} {
    display: none;
  }
`;

export const RegLink = styled(Link)`
  ${dfdDefaultTheme.breakpoints.between('xs', 'md')} {
    display: none;
  }
`;

export const ProgressContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  ${dfdDefaultTheme.breakpoints.between('xs', 'md')} {
    flex-direction: column;
  }
`;
export const RegTypography = styled(Box)`
  ${dfdDefaultTheme.breakpoints.between('xs', 'md')} {
    display: flex;
    justify-content: center;
  }
`;

export const RegCloseIconLink = styled(Link)`
  float: right;
  ${dfdDefaultTheme.breakpoints.between('md', 'xl')} {
    display: none;
  }
`;

export const StyledMuiBox = styled(MuiBox)`
  margin-top: ${headerHeight}px;
  justify-content: center;
`;

export const CloseMuiBox = styled(MuiBox)`
  text-align: right;
`;

export const StyledUserGrid = styled(Grid)`
  padding: ${Spacing.large}px;
`;

export const StyledFieldTip = styled(Paper)`
  &&& {
    background-color: ${Color.grayLight3};
    box-shadow: none;
    margin-top: ${Spacing.medium}px;
    ${dfdDefaultTheme.breakpoints.up('md')} {
      position: absolute;
      width: 185px;
      right: -185px;
      top: ${Spacing.xLarge}px;
    }
  }
`;
export const StyledPwdGrid = styled(Grid)`
  padding: ${Spacing.large}px;
`;

export const RequiredTextField = styled.span`
  color: ${Color.red};
`;

export const StyleTerms = styled(Paper)`
  height: 500px;
  padding: ${Spacing.medium}px;
  overflow-y: auto;
`;

export const RegistrationContainer = styled(Box)`
  background-color: ${Color.foreColor};
  flex-direction: column;
  display: flex;
  overflow: auto;
  ${dfdDefaultTheme.breakpoints.between('xs', 'sm')} {
    background-color: ${Color.white};
  }
`;

export const RegistrationStepperContainer = styled(Box)`
  width: 80%;
  min-height: 82vh;
  margin-left: 10%;
  margin-top: 10px;
  background-color: ${Color.white};
  paddingtop: 24px;
  paddingbottom: 35px;
  ${dfdDefaultTheme.breakpoints.between('xs', 'sm')} {
    width: 100%;
    margin-left: 0px;
    margin-top: 20px;
    margin-top: 36px;
  }
`;

export const RegistrationStepper = styled(Box)`
  padding-top: 24px;
  padding-bottom: 35px;
  ${dfdDefaultTheme.breakpoints.between('xs', 'sm')} {
    padding-bottom: 0px;
  }
`;

export const RegistrationHeaderContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  ${dfdDefaultTheme.breakpoints.between('xs', 'sm')} {
    flex-direction: column-reverse;
  }
`;
export const RegistrationHeaderLogoContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-direction: row;
  margin: 16px 0 16px 0;
  max-height: 40px;
  ${dfdDefaultTheme.breakpoints.between('xs', 'sm')} {
    flex-direction: row;
  }
`;

export const RegistrationMainContainer = styled(Box)`
  padding: 2px;
  ${dfdDefaultTheme.breakpoints.between('xs', 'sm')} {
    padding-right: 24px;
    padding-left: 24px;
  }
`;

export const RegistrationTitle = styled(Typography)`
  ${dfdDefaultTheme.breakpoints.between('xs', 'sm')} {
    position: fixed;
    width: 100%;
    top: 0;
    left: 0px;
    padding: 8px 0px 16px 0px;
    z-index: 100;
    background-color: ${Color.white};
    font-size: 22px;
    font-weight: 600;
  }
`;

export const FooterText = styled.div`
  color: ${Color.textLight};
  font-family: ${fontFamily};
  font-size: ${smallFontSize};
  line-height: 24px;
`;

export const CrossIconContainer = styled.div`
  display: none;
  ${dfdDefaultTheme.breakpoints.between('xs', 'sm')} {
    display: inline-block;
    right: 18px;
    bottom: 8px;
    position: absolute;
  }
`;
